import moment from "moment";
import {
  ChangeGlobalIsLoading,
  GlobalNavigate,
  GlobalTranslate,
} from "./Middleware.Helper";
import {removeAllPendingRequestsRecordHttp} from "./HttpMethod.Helper";
import {deletePermissions, LoginActions} from "../Store/Actions";
import {storageService} from "../utils";
import {showError} from "./Tostify.Helper";
import {TokenRefreshService} from "../Services";

/**
 * to call the refresh API service.
 * @description delay the refresh API until the pending requests are completed.
 */
const waitForAllRequestsToComplete = () =>
  new Promise((resolve) => {
    const intervalId = setInterval(() => {
      const requestsCounter = localStorage.getItem("APIRequestsCounter")
        ? +localStorage.getItem("APIRequestsCounter")
        : 0;
      if (requestsCounter <= 0) {
        clearInterval(intervalId);
        resolve();
      }
    }, 150); // check every 150 milliseconds
  });

/**
 * to call the refresh API service.
 * @param dispatch
 */
const getRefreshTokenHandler = async (dispatch) => {
  const url = new URL(window.location.href);
  const searchParams = new URLSearchParams(url.search);
  const ssoTokenKey = searchParams.get("token_key");
  if (
    !localStorage.getItem("user_token") ||
    (localStorage.getItem("user_token") && ssoTokenKey)
  )
    return;
  ChangeGlobalIsLoading(true);
  await waitForAllRequestsToComplete();
  localStorage.setItem("isRefreshTokenInProgress", "yes");
  const response = await TokenRefreshService();
  ChangeGlobalIsLoading(false);
  localStorage.setItem("isRefreshTokenInProgress", "no");
  if (response && response.status === 200) {
    localStorage.setItem(
      "user_token_expiry",
      response.data.results.token_expiry
    );
    localStorage.setItem("user_token", response.data.results.token);
    ScheduleTokenRefresh(dispatch);
    // Assuming updateToken handles updating the Redux state and local storage
  } else {
    showError(
      (GlobalTranslate &&
        GlobalTranslate.t("Shared:failed-to-refresh-token")) ||
        "Failed to refresh token!",
      response
    );
    logoutHandler(dispatch);
  }
};

const logoutHandler = (dispatch) => {
  removeAllPendingRequestsRecordHttp();
  dispatch(LoginActions.logout());
  dispatch(LoginActions.reset());
  dispatch(deletePermissions());
  setTimeout(() => {
    storageService.clearLocalStorage();
    GlobalNavigate("/accounts/login");
  }, 100);
};

let timeOutRef = null;

/**
 * Refresh the token just before it expires.
 * @param dispatch
 */
export const ScheduleTokenRefresh = (dispatch) => {
  const url = new URL(window.location.href);
  const searchParams = new URLSearchParams(url.search);
  const ssoTokenKey = searchParams.get("token_key");
  if (
    !localStorage.getItem("user_token") ||
    (localStorage.getItem("user_token") && ssoTokenKey)
  )
    return;
  const expiresIn =
    (localStorage.getItem("user_token_expiry") &&
      +localStorage.getItem("user_token_expiry")) ||
    undefined;
  const currentTime = moment().unix();
  const refreshTime = expiresIn - currentTime - (5 * 60); // Refresh 5 minutes before expiry
  if (refreshTime * 1000 >= 2147483647) return;
  timeOutRef =
    (sessionStorage.getItem("refreshTimeOutRef") &&
      +sessionStorage.getItem("refreshTimeOutRef")) ||
    null;

  if (refreshTime > -200) {
    if (timeOutRef) clearTimeout(timeOutRef);
    timeOutRef = setTimeout(() => {
      // this logic is to prevent multiple refresh token calls at the same time if
      // there are multiple open tabs
      if (!localStorage.getItem("tokenLeaderTab"))
        localStorage.setItem("tokenLeaderTab", sessionStorage.getItem("tabID"));
      if (
        localStorage.getItem("tokenLeaderTab") ===
        sessionStorage.getItem("tabID")
      )
        void getRefreshTokenHandler(dispatch);
      else
        setTimeout(() => {
          ScheduleTokenRefresh(
            JSON.parse(localStorage.getItem("user_token")),
            dispatch
          );
        });
    }, refreshTime * 1000);
    sessionStorage.setItem("refreshTimeOutRef", timeOutRef);
  }
  // Convert seconds to milliseconds
  else logoutHandler(dispatch);
};
